import React, { Component, Suspense } from "react";
import ContentWrapper from "./../../../template/Layout/ContentWrapper";
import { Tab } from "semantic-ui-react";
import Documents from "../../Components/Documents";
import queryString from "query-string";
import { withRouter } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import axios from "axios";
import _ from "lodash";
import { Services } from "../../../../repositories/clients/Services";
import MpaJsonForm from "../../../../models/mapJson.js";
import MpaJsonAdminForm from "../../../../models/mapJsonAdmin.js";
import Loader from "../../../Global/Loader";
import { withNamespaces } from "react-i18next";

const Events = React.lazy(() => import("./Events"));
const SumaryDetail = React.lazy(() => import("./Sumary/SumaryDetail"));
const HashTable = require("../../Components/utils/HashTable");

class ShipmentDetail extends Component {
  state = {
    isMobil: false,
    firstLoadDocs: true,
    scrollLine: true,
    tabActive: 0,
    fullLoader: false,
    markers: [],
    Resumen: [],
    polylineData: [],
    dataMap: [],
    id: this.props.match.params.id,
    rolId: this.props._rolId,
    userId: this.props._user,
    allSteps: [],
    documentos: [],
    AllcommentsData: [
      {
        id: 1,
        title: this.props.t("request"),
        data: [
          {
            expanded: false,
            id: "TP-SEA-2022-0025",
            message: [],
          },
          {
            expanded: false,
            id: "TP-SEA-2022-234",
            message: [],
          },
        ],
      },
      {
        id: 2,
        title: this.props.t("transport_plan"),
        data: [
          {
            expanded: false,
            id: "EP/COA/AI/S0025",
            message: [],
          },
        ],
      },
    ],
    commentsData: [],
    users: [],
    tables: [
      {
        columns: [
          {
            label: this.props.t("secuence"),
            key: "LegNumber",
            minWidth: 70,
            maxWidth: 70,
          },

          {
            label: this.props.t("transport_mode"),
            key: "TransportMode",
          },
          { label: this.props.t("carrier"), key: "Carrier" },
          { label: this.props.t("flight_voyage"), key: "Voyage_FlightNo" },
          { label: this.props.t("vessel"), key: "Vessel" },
          { label: this.props.t("origin"), key: "POL" },
          { label: this.props.t("destination"), key: "POD" },
          { label: this.props.t("etd"), key: "ETD" },
          { label: this.props.t("eta"), key: "ETA" },
          { label: this.props.t("atd"), key: "ATD" },
          { label: this.props.t("ata"), key: "ATA" },
        ],
        data: [],
        title: this.props.t("routing"),
        key: "Rutas",
      },
      {
        columns: [
          {
            label: this.props.t("package"),
            key: "Package",
          },
          {
            label: this.props.t("package_type"),
            key: "PackageType",
          },
          {
            label: this.props.t("weight"),
            key: "UOMTotalWeight",
          },
          {
            label: this.props.t("volume"),
            key: "UOMTotalVolume",
          },
        ],
        data: [],
        title: this.props.t("packages"),
        key: "infoEmbarque",
      },
    ],
    tablesHouseAir: [
      {
        columns: [
          {
            label: this.props.t("secuence"),
            key: "LegNumber",
            minWidth: 70,
            maxWidth: 70,
          },

          {
            label: this.props.t("transport_mode"),
            key: "TransportMode",
          },
          { label: this.props.t("carrier"), key: "Carrier" },
          { label: this.props.t("flight_voyage"), key: "Voyage_FlightNumber" },
          { label: this.props.t("vessel"), key: "Vessel" },
          { label: this.props.t("origin"), key: "POL" },
          { label: this.props.t("destination"), key: "POD" },
          { label: this.props.t("etd"), key: "ETD" },
          { label: this.props.t("eta"), key: "ETA" },
          { label: this.props.t("atd"), key: "ATD" },
          { label: this.props.t("ata"), key: "ATA" },
        ],
        data: [],
        title: this.props.t("routing"),
        key: "Rutas",
      },
      {
        columns: [
          {
            label: this.props.t("package"),
            key: "Package",
          },
          {
            label: this.props.t("package_type"),
            key: "PackageType",
          },
          {
            label: this.props.t("weight"),
            key: "UOMTotalWeight",
          },
          {
            label: this.props.t("volume"),
            key: "UOMTotalVolume",
          },
        ],
        data: [],
        title: this.props.t("packages"),
        key: "infoEmbarque",
      },
    ],
    tables2: [
      {
        columns: [
          {
            label: this.props.t("secuence"),
            key: "LegNumber",
            minWidth: 70,
            maxWidth: 70,
          },

          {
            label: this.props.t("transport_mode"),
            key: "TransportMode",
          },
          { label: this.props.t("carrier"), key: "Carrier" },
          { label: this.props.t("flight_voyage"), key: "Voyage_FlightNo" },
          { label: this.props.t("vessel"), key: "Vessel" },
          { label: this.props.t("origin"), key: "POL" },
          { label: this.props.t("destination"), key: "POD" },
          { label: this.props.t("etd"), key: "ETD" },
          { label: this.props.t("eta"), key: "ETA" },
          { label: this.props.t("atd"), key: "ATD" },
          { label: this.props.t("ata"), key: "ATA" },
        ],
        data: [],
        title: this.props.t("routing"),
        key: "Rutas",
      },
      {
        columns: [
          {
            label: this.props.t("container_num"),
            key: "ContainerNo",
            custom: (value) => {
              return <span className="linkCard">{value.ContainerNo}</span>;
            },
            minWidth: 250,
            maxWidth: 250,
          },
          {
            label: this.props.t("container_type"),
            key: "Type",
          },
          { label: this.props.t("seal"), key: "Seal" },
          {
            label: this.props.t("delivery_mode"),
            key: "DeliveryMode",
          },
          {
            label: this.props.t("gross_weight"),
            key: "GrossWeight",
            custom: (value) => (
              <span>
                {this.currencyFormatter({
                  currency: "USD",
                  value: Number(value.GrossWeight),
                })}
              </span>
            ),
          },
          {
            label: this.props.t("length_width_height"),
            key: "Dimension",
          },
          {
            label: this.props.t("empty_gate_in"),
            key: "EmptyGateIn",
          },
          {
            label: this.props.t("empty_gate_out"),
            key: "EmptyGateOut",
          },
        ],
        data: [],
        title: this.props.t("containers"),
        key: "Containers",
      },
    ],
  };

  currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      currency,
    });
    return formatter.format(value);
  }

  componentDidMount = async () => {
    const searchParams = new URLSearchParams(document.location.search);

    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMobil: isMobileDevice,
      tabActive: Boolean(searchParams.get("tab"))
        ? Number(searchParams.get("tab"))
        : 0,
    });

    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }

    Promise.all([
      this.getShipmentsForId(),
      this.getEvents(notifyActiveComment),
      this.findShipmentDocument(),
    ]).finally(() => {
      this.setState({ fullLoader: true });
    });
  };

  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }

    const newProp = nextProps.match.params.id
      ? nextProps.match.params.id
      : this.props.match.params.id;
    this.setState({ id: newProp, fullLoader: false }, () => {
      Promise.all([
        this.getShipmentsForId(),
        this.getEvents(notifyActiveComment),
        this.findShipmentDocument(),
      ]).finally(() => {
        this.setState({ fullLoader: true });
      });
    });
  };

  getEvents = async (notifyActiveComment) => {
    try {
      const searchParams = new URLSearchParams(document.location.search);
      const { id } = this.state;
      const response = await axios.get(
        `${Services.TRACEABILITY.path}trazabilidad/shipmentevents/${id}?lang=${this.props.lng}`
      );
      const dataEvents = response.data.data;
      const newSteps = response.data.steps;
      this.setState({
        steps: newSteps,
        allSteps: dataEvents,
        tabActive: Boolean(searchParams.get("tab"))
          ? Number(searchParams.get("tab"))
          : notifyActiveComment
          ? 2
          : 0,
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: ShipmentsDetail.js ~ ShipmentDetail ~ getEvents= ~ error",
        error
      );
    }
  };

  handleBack = () => {};

  getShipmentsForId = async () => {
    try {
      const success = await axios.get(
        `${Services.TRACEABILITY.path}trazabilidad/dataShipments/${this.state.id}?user=${this.props._user}&lang=${this.props.lng}`
      );
      let Info = [];
      Info.push(success.data.data.infoEmbarque);

      let markers = [];
      let polylineData = [];

      if (
        success.data.data?.infoEmbarque?.POLLatitude &&
        success.data.data?.infoEmbarque?.POLLongitude
      ) {
        let obj = {
          anchorX: 20,
          anchorY: 20,
          key: 1,
          title: this.props.t("origin"),
          data: success.data.data.infoEmbarque,
          position: {
            lat: success.data.data.infoEmbarque.POLLatitude,
            lng: success.data.data.infoEmbarque.POLLongitude,
          },
          icon: {
            url: "https://magiclog.blob.core.windows.net/onboardpic/onboard_marker.png",
          },
        };
        let position = {
          lat: Number(success.data.data.infoEmbarque.POLLatitude),
          lng: Number(success.data.data.infoEmbarque.POLLongitude),
        };
        polylineData.push(position);
        markers.push(obj);
      }
      if (
        success.data.data?.infoEmbarque?.PODLatitude &&
        success.data.data?.infoEmbarque?.PODLongitude
      ) {
        let obj = {
          anchorX: 20,
          anchorY: 20,
          key: 2,
          data: success.data.data.infoEmbarque,
          title: this.props.t("destination"),
          position: {
            lat: success.data.data.infoEmbarque.PODLatitude,
            lng: success.data.data.infoEmbarque.PODLongitude,
          },
          icon: {
            url: "https://magiclog.blob.core.windows.net/onboardpic/onboard_marker.png",
          },
        };
        let position = {
          lat: Number(success.data.data.infoEmbarque.PODLatitude),
          lng: Number(success.data.data.infoEmbarque.PODLongitude),
        };
        polylineData.push(position);
        markers.push(obj);
      }
      const MpaJson = Number(this.state.rolId) === 1 ? MpaJsonAdminForm : MpaJsonForm;
      let resumeModel = _.cloneDeep(
        success.data.data.infoEmbarque.ShipmentType === "FCL"
          ? MpaJson.cardResumenTerrestreFCL
          : MpaJson.cardResumenTerrestre
      );
      if (Info[0].TransportModeId === 1) {
        resumeModel = _.cloneDeep(
          success.data.data.infoEmbarque.ShipmentType === "FCL"
            ? MpaJson.cardResumenMaritimoFCL
            : MpaJson.cardResumenMaritimo
        );
      } else if (Info[0].TransportModeId === 2) {
        resumeModel = _.cloneDeep(
          success.data.data.infoEmbarque.ShipmentType === "FCL"
            ? MpaJson.cardResumenAereoFCL
            : MpaJson.cardResumenAereo
        );
      }
      let newResume = resumeModel.map((f) => {
        f.data.map((g) => {
          if (g.infoTool) {
            g.arrayInfoTool.map((aif) => {
              aif.value = success.data.data.infoEmbarque[aif.key];
              return aif;
            });
          }
          g.value = success.data.data.infoEmbarque[g.key];
          g.value2 = success.data.data.infoEmbarque[g.key2];
          if (f.infoTool) {
            f.arrayInfoTool.map((aif) => {
              aif.value = success.data.data.infoEmbarque[aif.key];
              return aif;
            });
          }

          if (g.table) {
            g.data.push(
              success.data.data.historico[g.EventId]
                ? success.data.data.historico[g.EventId]
                : []
            );
          }
          return g;
        });
        return f;
      });

      let isHouseAir = success.data.data.infoEmbarque.TransportMode === "AIR";

      if (isHouseAir) {
        let containers = success.data.data.Containers;

        if (containers && containers.length > 0) {
          const Table = new HashTable();

          for (var i = 0; i < containers.length; i++) {
            let dataWaybill = containers[i];

            if (Table.exist(dataWaybill.HouseReference)) {
              let Factura = Table.getElement(dataWaybill.HouseReference);
              Factura.sub.push({
                Packages: dataWaybill.Packages,
                Pieces: dataWaybill.Pieces,
                Measure: dataWaybill.Measure,
                UOMWeightDescription: dataWaybill.UOMWeightDescription,
                UOMGrossWeightDescription:
                  dataWaybill.UOMGrossWeightDescription,
                UOMVolumeDescription: dataWaybill.UOMVolumeDescription,
                UOMDimensionsDescription: dataWaybill.UOMDimensionsDescription,
                LineHouse: dataWaybill.LineHouse,
                GoodsDescription: dataWaybill.GoodsDescription,
              });
              Table.updateElement(dataWaybill.HouseReference, Factura);
            } else {
              Table.addElement(dataWaybill.HouseReference, {
                ...dataWaybill,
                sub: [
                  {
                    Packages: dataWaybill.Packages,
                    Pieces: dataWaybill.Pieces,
                    Measure: dataWaybill.Measure,
                    UOMWeightDescription: dataWaybill.UOMWeightDescription,
                    UOMGrossWeightDescription:
                      dataWaybill.UOMGrossWeightDescription,
                    UOMVolumeDescription: dataWaybill.UOMVolumeDescription,
                    UOMDimensionsDescription:
                      dataWaybill.UOMDimensionsDescription,
                    LineHouse: dataWaybill.LineHouse,
                    GoodsDescription: dataWaybill.GoodsDescription,
                  },
                ],
              });
            }
          }
          success.data.data.Waybill = Table.elements();
        }
      }

      let netTabla = (
        success.data.data.infoEmbarque.ShipmentType === "FCL"
          ? this.state.tables2
          : isHouseAir
          ? this.state.tablesHouseAir
          : this.state.tables
      ).map((f) => {
        f.data =
          success.data.data[f.key] && success.data.data[f.key].length > 0
            ? success.data.data[f.key]
            : success.data.data[f.key]
            ? [success.data.data[f.key]]
            : [{}];
        return f;
      });

      if (success.data.data.infoEmbarque.TransportMode !== "SEA") {
        netTabla.forEach((table) => {
          if (table.key === "Rutas") {
            let newColumns = [];
            table.columns.forEach((col) => {
              if (col.key !== "Vessel") {
                newColumns.push(col);
              }
            });
            table.columns = newColumns;
          }
        });
      }
      this.setState({
        markers: markers,
        dataMap: polylineData,
        polylineData: polylineData,
        Resumen: newResume,
        tables: netTabla,
        users: success.data.data.users,
        shipment: success.data.data.infoEmbarque,
        DoEmbarque: success.data.data.infoEmbarque ? Info[0].DoEmbarque : "",
        ModoTransporte: success.data.data.infoEmbarque
          ? Info[0].ModoTransporte
          : "",
        cliente: success.data.data.infoEmbarque ? Info[0].Cliente : "",
      });
    } catch (error) {
      console.log(
        "🚀 ~ file: ShipmentsDetail.js ~ ShipmentDetail ~ getShipmentsForId= ~ error",
        error
      );
    }
  };

  deleteMessage = async (idDelete) => {
    axios
      .delete(
        `${Services.TRACEABILITY.path}trazabilidad/delete-comment/${idDelete}`
      )
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_deleted"));
        // message.success("Comentario eliminado correctamente");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  findShipmentDocument = async () => {
    try {
      let resp = await axios.get(
        `${Services.TRACEABILITY.path}trazabilidad/docShipments/${this.state.id}?user=${this.props._user}&lang=${this.props.lng}`
      );
      //LIMITAR DOCUMENTOS POR ROL
      let Documents = [];
      if (resp.data.data && resp.data.data.length > 0) {
        Documents = resp.data.data;

        Documents = Documents.filter((d) => {
          if (d.Category === "INV") {
            const [dayD, monthD, yearD] = d.SaveDateUTC.split("-").map(Number);
            const [day, month, year] = "01-01-2026".split("-").map(Number);

            const docDate = new Date(yearD, monthD - 1, dayD);
            const validateDate = new Date(year, month - 1, day);

            return docDate > validateDate;
          }

          return true; // mantiene los que no son INV
        });

        this.setState({
          documentos: Documents,
        });
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: ShipmentsDetail.js:748 ~ ShipmentDetail ~ findShipmentDocument= ~ error:",
        error.message
      );
      this.setState({ documentos: [] });
    }
  };

  render() {
    let logoUrl =
      this.state.ModoTransporte === "AIR"
        ? "https://magiclog.blob.core.windows.net/onboardpic/air_shipment.png"
        : this.state.ModoTransporte === "ROA"
        ? "https://magiclog.blob.core.windows.net/onboardpic/sea_shipment.png"
        : this.state.ModoTransporte === "SEA"
        ? "https://magiclog.blob.core.windows.net/onboardpic/road_shipment.png"
        : "https://magiclog.blob.core.windows.net/onboardpic/listOther.png";
    let {
      markers,
      polylineData,
      Resumen,
      tables,
      shipment,
      fullLoader,
      tabActive,
      isMobil,
    } = this.state;

    return (
      <>
        <Loader hidden={fullLoader} />
        <ContentWrapper>
          <div>
            <div className="content-heading header-seacargo">
              <legend className="legendBasic">
                <i className="icon-10abr23-iconosmagicdome-06_"></i>
                {this.props.t("shipments_detail")}
                &nbsp;{shipment ? shipment.ShipmentNumber : "---"}
              </legend>
              <div className="_btnBack d-flex align-items-center">
                <Icon.Group>
                  <Icon
                    name="angle left"
                    onClick={() => this.props.history.push("/trazabilidad")}
                  />
                </Icon.Group>
                <span
                  className="_text_btn-back"
                  onClick={() => this.props.history.push("/trazabilidad")}
                >
                  {this.props.t("back")}
                </span>
              </div>
            </div>
          </div>
          <Tab
            menu={{
              secondary: true,
              className: "wrapped",
              pointing: true,
              style: { fontSize: "14px" },
            }}
            menuPosition="right"
            onTabChange={(event, data) => {
              if (data.activeIndex === 2 && this.state.firstLoadDocs) {
                this.setState({ firstLoadDocs: false });
              }
              this.setState({ tabActive: data.activeIndex });
            }}
            activeIndex={tabActive}
            panes={[
              {
                menuItem: this.props.t("summary"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <SumaryDetail
                      markers={markers}
                      dataMap={polylineData}
                      polylineData={polylineData}
                      Resumen={Resumen}
                      tables={tables}
                      shipment={shipment}
                      steps={this.state.steps}
                    />
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("events"),
                render: () => (
                  <Suspense fallback={<div>Loading...</div>}>
                    <hr></hr>
                    <Events
                      cliente={this.state.cliente}
                      NIT={this.state.NIT}
                      Grupo={this.state.Grupo}
                      logoUrl={logoUrl}
                      DoEmbarque={this.state.DoEmbarque}
                      HBL_HAWB={this.state.HBL_HAWB}
                      Estatus={this.state.Estatus}
                      allSteps={this.state.allSteps}
                      steps={this.state.steps}
                    />{" "}
                  </Suspense>
                ),
              },
              {
                menuItem: this.props.t("documents"),
                render: () => (
                  // <div>
                  <Suspense fallback={<div>Loading...</div>}>
                    <div
                      className="content-wrapper"
                      style={{ paddingRight: "0", paddingLeft: "0" }}
                    >
                      <Documents
                        dataDoc={this.state.documentos}
                        docBase64={true}
                        rolId={1}
                        shipment=""
                        shipmentDataPlane=""
                        isMobil={isMobil}
                      />
                    </div>
                  </Suspense>
                ),
              },
            ]}
          />
        </ContentWrapper>
      </>
    );
  }
}
export default withNamespaces()(withRouter(ShipmentDetail));
